export default __webpack_public_path__ + "ab85c528808794e9c9360933a7031b97.png";